var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signature"},[(_vm.label)?_c('div',{staticClass:"signature__label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"signature__box",style:(_vm.styles),on:{"click":_vm.click}},[_c('span',[_vm._v(_vm._s(_vm.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }